import { render, staticRenderFns } from "./systemPictures.vue?vue&type=template&id=65337b1c&scoped=true"
import script from "./systemPictures.vue?vue&type=script&lang=js"
export * from "./systemPictures.vue?vue&type=script&lang=js"
import style0 from "./systemPictures.vue?vue&type=style&index=0&id=65337b1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65337b1c",
  null
  
)

export default component.exports